export default "__VITE_ASSET__CteL0kvL__"